<template>
  <div
    v-if="selectedJob"
    class="bg-white shadow overflow-hidden sm:rounded-lg w-full sm:mt-6"
  >
    <div class="bg-white px-4 py-5 sm:px-6">
      <div class="flex space-x-3">
        <div class="min-w-0 flex-1">
          <p class="text-sm font-medium text-gray-900">
            <a
              >Job for {{ selectedJob.studio.description }} in {{ selectedJob.studio.street }},
              {{ selectedJob.studio.city }}</a
            >
          </p>
          <p class="text-sm text-gray-500">
            <a
              >Status:
              <span
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
              >
                {{ selectedJob.status }}
              </span></a
            >
          </p>
        </div>
        <div
          class="flex-shrink-0 self-center flex"
          v-if="user.type != 'cleaner'"
        >
          <div class="relative z-30 inline-block text-left">
            <div>
              <button
                type="button"
                class="-m-2 p-2 rounded-full flex items-center text-gray-400 hover:text-gray-600"
                id="menu-0-button"
                @click="optionsMenu = !optionsMenu"
              >
                <span class="sr-only">Open options</span>
                <!-- Heroicon name: solid/dots-vertical -->
                <svg
                  class="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                  />
                </svg>
              </button>
            </div>

            <!--
          Dropdown menu, show/hide based on menu state.

          Entering: "transition ease-out duration-100"
            From: "transform opacity-0 scale-95"
            To: "transform opacity-100 scale-100"
          Leaving: "transition ease-in duration-75"
            From: "transform opacity-100 scale-100"
            To: "transform opacity-0 scale-95"
        -->
            <div
              class="origin-top-right absolute right-0 mt-2 w-36 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
              role="menu"
              v-if="optionsMenu"
            >
              <div class="py-1" role="none">
                <!-- Active: "bg-gray-100 text-gray-900", Not Active: "text-gray-700" -->
                <a
                  v-if="selectedJob.status == 'open' || selectedJob.status == 'finished'"
                  class="text-gray-700 flex px-4 py-2 text-sm"
                  role="menuitem"
                  tabindex="-1"
                  id="menu-0-item-0"
                >
                  <router-link :to="{ path: '/jobs/edit/' + index }"
                    >Edit Job</router-link
                  >
                </a>
                <a
                  v-if="user.type == 'admin'"
                  class="text-gray-700 flex px-4 py-2 text-sm"
                  role="menuitem"
                  tabindex="-1"
                  id="menu-0-item-1"
                  @click="deleteJob(selectedJob._id)"
                >
                  <span>Delete job</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
      <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
        <div class="sm:col-span-1">
          <dt class="text-sm font-medium text-gray-500">Address</dt>
          <dd class="mt-1 text-sm text-gray-900">
            {{ selectedJob.studio.country }}
          </dd>
          <dd class="mt-1 text-sm text-gray-900">
            {{ selectedJob.studio.region }}, {{ selectedJob.studio.city }},
            {{ selectedJob.studio.zipCode }}
          </dd>
          <dd class="mt-1 text-sm text-gray-900">
            {{ selectedJob.studio.street }}
          </dd>
        </div>
        <div class="sm:col-span-1">
          <dt class="text-sm font-medium text-gray-500">Date</dt>
          <dd class="mt-1 text-sm text-gray-900">
            {{ selectedJob.dateOfJob | moment('timezone', 'Europe/Brussels','dddd, MMMM Do YYYY') }}
          </dd>
        </div>
        <div class="sm:col-span-1" v-if="selectedJob.studio.startHour && selectedJob.studio.endHour">
            <dt class="text-sm font-medium text-gray-500">Available between</dt>
            <dd class="mt-1 text-sm text-gray-900">{{selectedJob.studio.startHour | moment('timezone', 'Europe/Brussels',"HH:mm")}} and {{selectedJob.studio.endHour | moment('timezone', 'Europe/Brussels',"HH:mm")}}</dd>
          </div>
        <div class="sm:col-span-1" v-if="selectedJob.studio.cleaningCost && (user.type == 'customer' || user.type == 'admin')">
          <dt class="text-sm font-medium text-gray-500">Expected cost</dt>
          <dd class="mt-1 text-sm text-gray-900">
            €
            {{
              selectedJob.studio.cleaningCost
            }}
          </dd>
        </div>
        <div class="sm:col-span-1" v-if="selectedJob.studio.cleanerCost && (user.type == 'cleaner' || user.type == 'admin')">
          <dt class="text-sm font-medium text-gray-500">Expected revenue</dt>
          <dd class="mt-1 text-sm text-gray-900">
            €
            {{
              selectedJob.studio.cleanerCost
            }}
          </dd>
        </div>
        <div class="sm:col-span-1" v-if="selectedJob.expenses > 0">
          <dt class="text-sm font-medium text-gray-500">Expenses</dt>
          <dd class="mt-1 text-sm text-gray-900">
            €
            {{
              selectedJob.expenses
            }}
          </dd>
        </div>
        <div class="sm:col-span-2">
          <dt class="text-sm font-medium text-gray-500">Job description</dt>
          <dd class="mt-1 text-sm text-gray-900">
            {{ selectedJob.description }}
          </dd>
        </div>
        <div class="sm:col-span-2" v-if="(user.type =='customer' || user.type == 'admin') && selectedJob.cleaner">
          <dt class="text-sm font-medium text-gray-500">Cleaner</dt>
          <dd class="mt-1 text-sm text-gray-900">
            {{ selectedJob.cleaner.firstname }} {{ selectedJob.cleaner.lastname }}
          </dd>
        </div>
        <div class="sm:col-span-2" v-if="(user.type =='cleaner' || user.type == 'admin')">
          <dt class="text-sm font-medium text-gray-500">Job Created By</dt>
          <dd class="mt-1 text-sm text-gray-900">
            {{ selectedJob.creator.firstname }} {{ selectedJob.creator.lastname }}
          </dd>
        </div>
        <div
          v-if="user.type == 'cleaner' || user.type == 'admin'"
          class="sm:col-span-2"
        >
          <dt class="text-sm font-medium text-gray-500">
            Contact information Owner
          </dt>
          <div
            class="mt-1 flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-y-0 sm:space-x-4"
          >
            <button
              @click="gotoLink('mailto:' + selectedJob.creator.email)"
              class="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
            >
              <!-- Heroicon name: solid/mail -->
              <svg
                class="-ml-1 mr-2 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                />
                <path
                  d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                />
              </svg>
              <span>Email</span>
            </button>
            <button
              @click="gotoLink('tel:' + selectedJob.creator.phone)"
              class="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
            >
              <!-- Heroicon name: solid/phone -->
              <svg
                class="-ml-1 mr-2 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                />
              </svg>
              <span>Call</span>
            </button>
          </div>
        </div>
        <div
          v-if="
            (user.type == 'customer' &&
              (selectedJob.status == 'accepted' ||
                selectedJob.status == 'finished')) ||
              user.type == 'admin'
          "
          class="sm:col-span-2"
        >
          <dt class="text-sm font-medium text-gray-500">
            Contact information Cleaner
          </dt>
          <div
            class="mt-1 flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-y-0 sm:space-x-4"
          >
            <button
              @click="gotoLink('mailto:' + selectedJob.cleaner.email)"
              class="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
            >
              <!-- Heroicon name: solid/mail -->
              <svg
                class="-ml-1 mr-2 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                />
                <path
                  d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                />
              </svg>
              <span>Email</span>
            </button>
            <button
              @click="gotoLink('tel:' + selectedJob.cleaner.phone)"
              class="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
            >
              <!-- Heroicon name: solid/phone -->
              <svg
                class="-ml-1 mr-2 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                />
              </svg>
              <span>Call</span>
            </button>
          </div>
        </div>
        <div
          class="sm:col-span-1"
          v-if="user.type == 'cleaner' && selectedJob.status == 'open'"
        >
          <dt class="text-sm font-medium text-gray-500">Actions</dt>
          <dd class="mt-1 text-sm text-gray-900">
            <div class="sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
              <button
                type="button"
                class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
                @click="acceptJob(selectedJob._id)"
              >
                Accept
              </button>
              <button
                type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                @click="rejectJob(selectedJob._id)"
              >
                Decline
              </button>
            </div>
          </dd>
        </div>

        <div
          class="sm:col-span-2"
          v-if="user.type == 'cleaner' && selectedJob.status == 'accepted'"
        >
          <dt class="text-sm font-medium text-gray-500">Actions</dt>
          <div>
            <div class="flex justify-between mt-3">
              <label for="email" class="block text-sm font-medium text-gray-700"
                >Expenses</label
              >
              <span class="text-sm text-gray-500" id="email-optional"
                >Optional</span
              >
            </div>
            <div class="mt-1">
              <input
                type="text"
                name="email"
                id="email"
                class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                placeholder="5 €"
                aria-describedby="email-optional"
                v-model="expenses"
              />
            </div>
          </div>
          <dd class="mt-3 text-sm text-gray-900">
            <button
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
              @click="finishJob(selectedJob._id)"
            >
              Finish
            </button>
          </dd>
        </div>
        <div
          class="sm:col-span-2"
          v-if="user.type == 'customer' && selectedJob.status == 'finished'"
        >
          <dt class="text-sm font-medium text-gray-500">Actions</dt>
          <dd class="mt-1 text-sm text-gray-900">
            <button
              type="button"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
              @click="closeJob(selectedJob._id)"
            >
              Archive Job
            </button>
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'

export default {
  name: 'jobDetail',
  data() {
    return {
      index: null,
      optionsMenu: false,
      expenses: 0,
      selectedJob: null,
    }
  },
  components: {},
  computed: {
    ...mapGetters('user', {
      user: 'currentUser',
    }),
    ...mapGetters('job', {
      jobs: 'jobList',
    }),
  },
  methods: {
    gotoLink(url) {
      location.href = url
    },
    deleteJob(id) {
      this.$store.dispatch('job/deleteJob', id)
      this.$router.push('/')
    },
    acceptJob(id) {
      this.$store.dispatch('job/acceptJob', id)
    },
    rejectJob(id) {
      this.$store.dispatch('job/rejectJob', id)
    },
    closeJob(id) {
      this.$store.dispatch('job/closeJob', id)
      this.$router.push('/')
    },
    finishJob(id) {
      this.$store.dispatch('job/finishJob', { id, expenses: this.expenses })
    },
    getJobById(id) {
      let filtered = this.jobs.filter((job) => {
        if (job._id == id) return job
      })
      return filtered[0]
    },
  },
  mounted() {
    this.index = this.$route.params.index
    this.selectedJob = this.getJobById(this.index)
  },
}
</script>

<style></style>

<style></style>
